import React from "react";
import PropTypes from "prop-types";
import styles from "./CommonInputSenha.module.css";
import { GoEye, GoEyeClosed } from "react-icons/go";

/**
 * Input reutilizável para senhas
 */
function CommonInputSenha({
  label,
  id,
  value,
  onChange,
  required = false,
  auth = false,
  inputStyle = {},
  labelStyle = {},
  ...props
}) {
  const [hidden, setHidden] = React.useState(true);

  return (
    <>
      {label && (
        <>
          <label
            htmlFor={id}
            className={`${styles.label} ${auth && styles.authLabel}`}
            style={labelStyle}
          >
            {label}
          </label>
          {required && <span style={{ color: "#f46a6a" }}> *</span>}
        </>
      )}
      <div className={styles.inputGroup}>
        <input
          className={`${styles.input} ${auth && styles.authInput}`}
          type={hidden ? "password" : "text"}
          name={id}
          id={id}
          value={value}
          onChange={onChange}
          style={inputStyle}
          {...props}
        />
        <button
          className={styles.inputGroupButton}
          type="button"
          id={`passwordAddon${id}`}
          onClick={() => {
            setHidden(!hidden);
          }}
        >
          {hidden ? <GoEyeClosed /> : <GoEye />}
        </button>
      </div>
    </>
  );
}

CommonInputSenha.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  auth: PropTypes.bool,
  inputStyle: PropTypes.object,
  labelStyle: PropTypes.object,
};

export default CommonInputSenha;
